/**
 *  default prefix "FILTER_PANEL_"
 */

export const AT_SAVED_FILTER_SET = 'FILTER_PANEL_SAVED_FILTER_SET';
export const AT_SAVED_FILTER_ACTION_SET = 'FILTER_PANEL_SAVED_FILTER_ACTION_SET';
export const AT_SAVED_FILTERS_SET = 'FILTER_PANEL_SAVED_FILTERS_SET';
